// Colocated Driver.js tour for the My Receipts page, targeted at any
// wallet holder on first visit. Four steps: what the page is for, how
// to attach a receipt to a payout, how to find an old one, and what the
// per-row actions do. No FAQ outro; by the time a viewer reaches this
// page, they have already seen the shared outro from the first-login
// tour chain.

export const MY_RECEIPTS_OVERVIEW_TOUR_ID = 'my-receipts-overview-v1';

export const buildMyReceiptsOverviewTourSteps = () => [
    {
        element: '[data-tour="my-receipts-card"]',
        title: 'Attach the paper trail',
        description: 'Every successful payment can have a receipt attached to it. A photo, a scan, or a PDF from the vendor. Once uploaded, a reviewer on your account signs it off, and the payment is fully accounted for.',
        side: 'bottom',
        align: 'center',
    },
    {
        element: '[data-tour="my-receipts-add-button"]',
        title: 'Add a new receipt',
        description: 'Tap Add Receipt, pick the payment from the dropdown, and attach the file (JPG, PNG or PDF, up to 2 MB). Submit and the receipt lands here as Pending, waiting for a reviewer.',
        side: 'bottom',
        align: 'end',
    },
    {
        element: '[data-tour="my-receipts-filters"]',
        title: 'Find an old one',
        description: 'Search by tag, MPESA code, or amount. Narrow by a date range. Anything that matches shows up below.',
        side: 'bottom',
        align: 'start',
    },
    {
        element: '[data-tour="my-receipts-list"]',
        title: 'Follow what happens next',
        description: 'Each row shows the amount, date, MPESA code, and its status. Use the eye icon to view the file. While a receipt is still Pending you can delete it here; once a reviewer has approved or rejected it, the trash icon disappears and the record is final.',
        side: 'top',
        align: 'center',
    },
];
